import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import {
	UntypedFormGroup,
	UntypedFormControl,
	Validators,
} from "@angular/forms";
import { RequestForm } from "../../../partials/form-state/form-state.component";

import { Observable, OperatorFunction } from "rxjs";
import {
	switchMap,
	debounceTime,
	distinctUntilChanged,
} from "rxjs/operators";

@Component({
	selector: "create-invoice",
	templateUrl: "./create-invoice.component.html",
	styleUrls: ["./create-invoice.component.scss"],
})
export class CreateInvoiceComponent implements OnInit {
	working: boolean = false;
	customers: any;
	companies: any[];

	invoiceForm = new RequestForm(
		true,
		new UntypedFormGroup({
			companyId: new UntypedFormControl("", [
				Validators.required,
				Validators.min(1),
			]),
			customerNumber: new UntypedFormControl("", [
				Validators.required,
			]),
			customerName: new UntypedFormControl("", [Validators.required]),
			ourReference: new UntypedFormControl("", []),
			yourReference: new UntypedFormControl("", []),
			remarks: new UntypedFormControl("", []),
		})
	);

	constructor(
		private http: HttpClient,
		private change: ChangeDetectorRef,
		private router: Router
	) {}

	ngOnInit() {
		this.loadCompanies();
    }

	getCustomers(term: string): Promise<{Name: string, CustomerNumber: string}[]> {
		return new Promise<{Name, CustomerNumber}[]>((resolve, reject) => {
			this.http.get(`/api/customers/${this.invoiceForm.controls.value.companyId}?name=${term}`).subscribe(
				(data: {Name, CustomerNumber}[]) => resolve(data),
				(error) => reject(error)
			);
		});
	}

	loadCompanies() {
		this.http.get("/api/companies").subscribe((data: any[]) => {
			this.companies = data;
			this.change.detectChanges();
		});
	}

	submitInvoice() {
		this.working = true;
		this.http.post("/api/invoices/create", this.invoiceForm.controls.value).subscribe(
			(invoice: any) => {
				console.log(invoice);
				this.router.navigate(["/invoices", invoice.id]);
			},
			(error) => {
				this.invoiceForm.setError(error.error);
				this.working = false;
				this.change.detectChanges();
			}
		);
	}

	onCompanyChange(event: any) {
		this.invoiceForm.controls.patchValue({ customerName: "", customerNumber: "" });
	}
	onCustomerNameChange(event: any) {
		if (!this.invoiceForm.controls.value.customerName) {
			this.invoiceForm.controls.patchValue({ customerNumber: "" });
		}
	}

	matchCustomers: OperatorFunction<string, { customerName, customerNumber }[]> = (text$: Observable<string>) =>
		text$.pipe(
			debounceTime(500),
			distinctUntilChanged(),
			switchMap(
				(term) =>
					term === ''
					? []
					: this.getCustomers(term).then((customers: {Name: string, CustomerNumber: string}[] ) => customers.map(
							(c) => { return { customerName: c.Name, customerNumber: c.CustomerNumber } }
						))
			)
		)

	selectedCustomerName($event) {
		// Prevent json item from being stored in text field
		$event.preventDefault();
		// Update customer number and name in form
		this.invoiceForm.controls.patchValue($event.item);
	}
}